import fetchApi from "../util/fetchApi";
import checkErrors from './checkErrors';


export const UCSApi = {
    async callUCSAPI(data) {
        return checkErrors(await fetchApi.api.post(`ucs/`, { data}));
    },

}


export default UCSApi;
